// Genesis Utilities
import ParameterValidator from '@mvps-genesis/parameter-validator';
import UAParser from 'ua-parser-js';

export default class InputPasswordToggle {

	/**
	 * The input element being validated.
	 *
	 * @var	@mvps-genesis/parameter-validator
	 */
	#validator;

	/**
	 * User Agent parser to assist on not showing the element on specific browsers
	 *
	 * @var	@mvps-genesis/parameter-validator
	 */
	#parser;

	/**
	 * @var	HTMLButtonElement Reference to the toggle DOM element
	 */
	element;

	/**
	 * Constructor of `InputPasswordToggle`
	 * @return {undefined}
	 */
	constructor () {
		this.#validator = new ParameterValidator(this);
		this.#parser = new UAParser();
		this.element = this.#validator.isElement(`element`, this.createToggleElement());

		this.passwordVisibleIcon = 'u-icon-eye-open';
		this.passwordNotVisibleIcon = 'u-icon-eye-closed';
	}

	/**
	 * Creates the toggle DOM element used to update the password input's state
	 * @return {HTMLButtonElement}
	 */
	createToggleElement () {
		const toggleElement = document.createElement('button');

		toggleElement.setAttribute('type', 'button');
		toggleElement.setAttribute('title', 'Show Password');
		toggleElement.setAttribute('aria-label', 'Show Password');

		toggleElement.classList.add('g-form-input-password__icon');
		toggleElement.classList.add('u-icon-eye-closed');

		return toggleElement;
	}

	/**
	 * Only allow this instance to be used in browsers that
	 * are not Microsoft IE or Edge. These browser have a native feature
	 * for password inputs
	 * @return {Boolean}
	 */
	isAllowed () {
		return ![
			'ie',
			'edge'
		].includes(this.#parser.getBrowser().name.toLowerCase());
	}

	/**
	 * Set the state of the element when the password input is type `text`
	 * @return {undefined}
	 */
	setContextTypeText () {
		this.element.classList.remove(this.passwordNotVisibleIcon);
		this.element.classList.add(this.passwordVisibleIcon);
		this.element.setAttribute('title', 'Hide Password');
		this.element.setAttribute('aria-label', 'Hide Password');
	}

	/**
	 * Set the state of the element when the password input is type `password`
	 * @return {undefined}
	 */
	setContextTypePassword () {
		this.element.classList.remove(this.passwordVisibleIcon);
		this.element.classList.add(this.passwordNotVisibleIcon);
		this.element.setAttribute('title', 'Show Password');
		this.element.setAttribute('aria-label', 'Show Password');
	}
}
